<div class="settings-page-container">
  @if (isLoading) {
    <div class="loader-container">
      <app-loading />
    </div>
  } @else {
    <div class="settings-content-card">
      <div class="main-settings-wrapper">
        <div class="side-menu-options">
          @for (menu of sideMenuOptions; track menu) {
            <button [class.active]="menu.isActive" (click)="changeMenu(menu.text)">{{ menu.text }}</button>
          }
        </div>
        @if (socialSettingsFormGroup) {
          <form class="settings-options-card" [formGroup]="socialSettingsFormGroup">
            @if (activeMenuItem?.text === menuOptions.ROOM) {
              <div class="scootaverse-access">
                <p class="section-title">Participants in my Scootaverse can access...</p>
                <mat-slide-toggle formControlName="canToast" class="custom-toggle-scootaverse" hideIcon="true">
                  <span class="flex items-center">
                    Make a toast
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="Clicking the “Make a Toast” button will make the user visible and audible to everyone in the room, and will lower other participants’ volume."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                <mat-slide-toggle formControlName="canConvo" class="custom-toggle-scootaverse" hideIcon="true">
                  <span class="flex items-center">
                    Start an ice breaker
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="Clicking the “Start an Ice Breaker” button will allow the user to display a question or prompt to everyone in the room."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                @if (moderatedChat) {
                  <mat-slide-toggle formControlName="canHostChat" class="custom-toggle-scootaverse" hideIcon="true">
                    <span class="flex items-center">
                      Host Chat
                      <img
                        src="/assets/images/help-icon.svg"
                        alt="help-icon"
                        class="m-l-24 help-icon"
                        matTooltip="Host chat will allow hosts to chat amongst themselves in a separate area from the main chat."
                        [matTooltipPosition]="'right'"
                      />
                    </span>
                  </mat-slide-toggle>

                  <mat-slide-toggle
                    formControlName="canChatModeration"
                    class="custom-toggle-scootaverse"
                    hideIcon="true"
                  >
                    <span class="flex items-center">
                      Chat Moderation
                      <img
                        src="/assets/images/help-icon.svg"
                        alt="help-icon"
                        class="m-l-24 help-icon"
                        matTooltip="Chat Moderation will allow all hosts to approve or dismiss messages sent to the room. "
                        [matTooltipPosition]="'right'"
                      />
                    </span>
                  </mat-slide-toggle>
                }

                <mat-slide-toggle
                  formControlName="canStartPhotoBooth"
                  class="custom-toggle-scootaverse"
                  hideIcon="true"
                >
                  <span class="flex items-center">
                    Photo booth
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="The Photo Booth feature allows a user to take a sequence of photos and GIFs of their screen that they can download or share to remember their experience."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                <mat-slide-toggle formControlName="anyoneCanPresent" class="custom-toggle-scootaverse" hideIcon="true">
                  <span class="flex items-center">
                    Anyone can present
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="If this is turned on, all attendees will be able to present to the room from a button in their options panel."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                <mat-slide-toggle formControlName="anyoneCanShare" class="custom-toggle-scootaverse" hideIcon="true">
                  <span class="flex items-center">
                    Anyone can share screen
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="If this is turned on, all attendees will be able to Share their screen to the room by clicking a button in their options panel."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                <mat-slide-toggle
                  formControlName="anyoneCanShareToGroup"
                  class="custom-toggle-scootaverse"
                  hideIcon="true"
                >
                  <span class="flex items-center">
                    Anyone can share screen to group
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="If this is turned on, all attendees will be able to Share their screen to those participants in their group."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                <mat-slide-toggle
                  formControlName="anyoneCanChangeMusic"
                  class="custom-toggle-scootaverse"
                  hideIcon="true"
                >
                  <span class="flex items-center">
                    Anyone can change room music
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="If this is turned on, all attendees will have the ability to change the room music in their options panel."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>

                @if (aiSummaries) {
                  <mat-slide-toggle
                    formControlName="aiSummaries"
                    class="custom-toggle-scootaverse"
                    hideIcon="true"
                    (change)="toggleAiSummaries($event, 'aiSummaries')"
                  >
                    <span class="flex items-center">
                      AI conversation summaries
                      <img
                        src="/assets/images/help-icon.svg"
                        alt="help-icon"
                        class="m-l-24 help-icon"
                        matTooltip="Enable or disable the AI-generated meeting summaries for attendees. When off, attendees will not receive a summary after the event."
                        [matTooltipPosition]="'right'"
                      />
                    </span>
                  </mat-slide-toggle>
                }

                <div class="divider"></div>

                <p class="section-title">Participants in my Scootaverse can gather in groups of...</p>
                <span class="flex">Current group size: {{ groupSize }}</span>
                <mat-slider
                  class="slider"
                  aria-labelledby="group-size-slider"
                  [max]="20"
                  [min]="2"
                  [discrete]="true"
                  [disabled]="socialIsOpen"
                  #ngSlider
                  ><input
                    placeholder="slider"
                    matSliderThumb
                    [value]="groupSize"
                    (change)="
                      onGroupSizeChange({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })
                    "
                    #ngSliderThumb="matSliderThumb"
                  />
                </mat-slider>

                @if (specialAccessGroup) {
                  <mat-slide-toggle
                    formControlName="specialAccessGroup"
                    class="custom-toggle-scootaverse"
                    hideIcon="true"
                  >
                    <span class="flex items-center">
                      Special Access Control
                      <img
                        src="/assets/images/help-icon.svg"
                        alt="help-icon"
                        class="m-l-24 help-icon"
                        matTooltip="Special Access Groups require attendees to request permission to join them. Anyone currently in the private group can approve a join request"
                        [matTooltipPosition]="'right'"
                      />
                    </span>
                  </mat-slide-toggle>
                }

                <div class="divider"></div>

                <mat-slide-toggle
                  formControlName="recordMeeting"
                  class="custom-toggle-scootaverse"
                  hideIcon="true"
                  (change)="toggleAiSummaries($event, 'recordMeeting')"
                >
                  <span class="flex items-center">
                    Transcribe the meeting and automatically record presentations
                    <img
                      src="/assets/images/help-icon.svg"
                      alt="help-icon"
                      class="m-l-24 help-icon"
                      matTooltip="Transcribing the meeting will record conversations in mingle mode. It will also record and transcribe any presentations automatically."
                      [matTooltipPosition]="'right'"
                    />
                  </span>
                </mat-slide-toggle>
              </div>
            } @else if (activeMenuItem?.text === menuOptions.MAP) {
              <div class="scootaverse-access">
                <div class="title-wrap">
                  <p class="section-title">Map Settings</p>
                  <span class="section-subtitle">
                    The minimap, by default, will be set to its opened mode. To set a different default mode, select one
                    of the modes from below.
                  </span>
                </div>

                <mat-radio-group aria-labelledby="minimap-mode-label" (change)="minimapModeChange($event)">
                  @for (mode of minimapModes; track mode) {
                    <mat-radio-button
                      [value]="mode.value"
                      class="custom-radio"
                      [checked]="minimapMode === mode.value"
                      [disabled]="socialIsOpen"
                    >
                      {{ mode.label }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            } @else if (activeMenuItem?.text === menuOptions.JOIN) {
              <mat-form-field class="join-settings-form">
                <mat-label>Join Settings</mat-label>
                <mat-select formControlName="socialPermissionType" [panelWidth]="null">
                  <mat-option [value]="socialPermissionTypeEnum.PUBLIC">
                    Only users with link can join
                    <img
                      alt="help-icon"
                      class="info-icon"
                      src="../../../../assets/images/help-icon.svg"
                      [matTooltip]="'Easiest way to have users join. Anyone who has the link can join.'"
                    />
                  </mat-option>
                  <mat-option [value]="socialPermissionTypeEnum.COMPANY">
                    Only users in my Organization can join
                    <img
                      alt="help-icon"
                      class="info-icon"
                      src="../../../../assets/images/help-icon.svg"
                      [matTooltip]="'Secure your social. Users must belong to your organization before joining.'"
                    />
                  </mat-option>
                </mat-select>
              </mat-form-field>

              @if (!isPermissionTypePublic) {
                <span class="section-subtitle flex m-b-14">
                  *This join setting will enforce participants to create a Scoot account in order to verify their
                  association to you and/ or your company
                </span>
              }
              <div class="scootaverse-access">
                <mat-slide-toggle
                  formControlName="anyoneCanStart"
                  (change)="changeTogleValue($event, 'hostAdmitted')"
                  class="custom-toggle-scootaverse"
                  hideIcon="true"
                >
                  Allow join before host
                </mat-slide-toggle>
                <mat-slide-toggle
                  formControlName="hostAdmitted"
                  class="custom-toggle-scootaverse"
                  hideIcon="true"
                  (change)="changeTogleValue($event, 'anyoneCanStart')"
                >
                  Require host admission
                  <img
                    src="/assets/images/help-icon.svg"
                    alt="help-icon"
                    class="m-l-24 help-icon"
                    matTooltip="If you enable host admission, you will not be able to allow a participant to join before the host."
                    [matTooltipPosition]="'right'"
                /></mat-slide-toggle>
              </div>
            } @else if (activeMenuItem?.text === menuOptions.HOSTS) {
              <div>
                <p>
                  Select other users within this account to be an alternate host for this room. Alternate hosts can
                  perform all host privileges. Alternate hosts must have a paid license to be selected.
                </p>

                <alternate-hosts-selector
                  (selectionChange)="onAlternateHostsChange($event)"
                  [showLicenseError]="showHostLicenseError"
                  [roomIdentifier]="alternateHostsIdentifier"
                ></alternate-hosts-selector>
              </div>
            }
          </form>
        }
      </div>
      <div class="save-settings">
        <app-home-button data-testid="scootaverse-settings-button" [disabled]="isSaving" (click)="save()"
          >Apply changes</app-home-button
        >
      </div>
    </div>
  }
</div>
